import request from 'local_modules/request'
import { constants } from 'helpers'
import { reducers, getState } from 'redux/core'


const setFetching = (isFetching) => reducers.marketplace.adminCatalogPage.setFetching(isFetching)

const fetchSchools = () => {
  const {
    marketplace: {
      layersNavigation: {
        category: selectedCategory, area: selectedArea,
      },
    },
  } = getState()
  
  const isRpc = selectedCategory === 'rpc'
  const prefix = isRpc ? constants.rpc : constants.edu
  return request.get(prefix.schools + `?all=false`)
    .then(({ data }) => data)
    .then((schools) => {
      reducers.marketplace.adminCatalogPage.setSchools(schools)
    })
    .catch((error) => {
      console.log(error)
    })
}

const fetchSchoolStages = () => {
  const {
    marketplace: {
      layersNavigation: {
        category: selectedCategory, area: selectedArea,
      },
    },
  } = getState()
  
  const isRpc = selectedCategory === 'rpc'
  const prefix = isRpc ? constants.rpc : constants.edu
  return request.get(prefix.schoolStages)
    .then(({ data }) => data)
    .then((schoolStages) => {
      reducers.marketplace.adminCatalogPage.setSchoolStages(schoolStages)
    })
    .catch((error) => {
      console.log(error)
    })
}

const fetchCategories = () => {
  const {
    marketplace: {
      layersNavigation: {
        category: selectedCategory, area: selectedArea,
      },
    },
  } = getState()
  
  const isRpc = selectedCategory === 'rpc'
  const url = isRpc ? constants.rpc.categories : constants.edu.categories
  const { marketplace: { layersNavigation: { toolType } } } = getState()

  return request.get(url + `/${toolType}?all=true`)
    .then(({ data }) => data)
    .then((categories) => {
      reducers.marketplace.adminCatalogPage.setCategories(categories)
    })
    .catch((error) => {
      console.log(error)
    })
}

const setRestricts = ({ id, restricts }) => {
  const {
    marketplace: {
      layersNavigation: {
        category: selectedCategory, area: selectedArea,
      },
    },
  } = getState()
  
  const isRpc = selectedCategory === 'rpc'
  const prefix = isRpc ? constants.rpc : constants.edu
  return request.post(prefix.nomenclatureSchool + `/${id}`, restricts)
    .then(({ data }) => data)
    .catch((error) => {
      console.log(error)
    })
}

const setCategories = (categories) => {
  const {
    marketplace: {
      layersNavigation: {
        category: selectedCategory, area: selectedArea,
      },
    },
  } = getState()
  
  const isRpc = selectedCategory === 'rpc'
  const prefix = isRpc ? constants.rpc : constants.edu
  const { marketplace: { layersNavigation: { toolType } } } = getState()

  const updatedCategories = categories.map(({ restricts, ...category }) => category)
  const updatedRestricts  = categories.filter(({ id }) => id).map(({ id, restricts }) => ({ id, restricts }))

  return Promise.all([
    request.post(prefix.categories + `/${toolType}?all=true`, updatedCategories),
    ...updatedRestricts.map(({ id, restricts }) => setRestricts({ id, restricts }))
  ])
    .then(([ { data } ]) => data)
    .catch((error) => {
      console.log(error)
    })
}


export default {
  setFetching,
  fetchSchools,
  fetchCategories,
  fetchSchoolStages,
  setCategories,
}
